"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterNullableSelectCellFactory = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const common_types_1 = require("../../../common/common-types");
const select_1 = require("../../../components/select/select");
const list_source_hook_1 = require("../../../utils/list-source-hook");
const table_context_1 = require("../table-context");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
function useFilterNullableSelectCellFactory(dataHook) {
    const Cell = react_1.useMemo(() => function FilterSelectCell({ disabled, value, onChange, onChangeState, state, }) {
        const source = dataHook();
        const { classes } = react_1.useContext(table_context_1.TableContext);
        const operations = useOperations();
        const handleOperationChange = event_callback_hook_1.useEventCallback((operation) => {
            onChangeState({
                ...state,
                operation,
                value: operation === common_types_1.ApiFilterOperation.EQ ? value : null,
            });
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classes.filterDialogItemSubWrapper },
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FILTER_CELL_SELECT_OPERATION", defaultMessage: "Operace" })),
                react_1.default.createElement("div", { className: classes.filterDialogItemValueWrapper },
                    react_1.default.createElement(select_1.Select, { disabled: disabled, source: operations, value: state.operation, onChange: handleOperationChange, valueIsId: true, clearable: false }))),
            state.operation === common_types_1.ApiFilterOperation.EQ && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: classes.filterDialogItemSubWrapper },
                    react_1.default.createElement(Typography_1.default, null,
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FILTER_CELL_SELECT_VALUE", defaultMessage: "Hodnota" })),
                    react_1.default.createElement("div", { className: classes.filterDialogItemValueWrapper },
                        react_1.default.createElement(select_1.Select, { disabled: disabled, source: source, value: value, onChange: onChange, valueIsId: true, clearable: false })))))));
    }, [dataHook]);
    Cell.source = dataHook();
    return Cell;
}
exports.useFilterNullableSelectCellFactory = useFilterNullableSelectCellFactory;
function useOperations() {
    const intl = react_intl_1.useIntl();
    return list_source_hook_1.useStaticListSource([
        {
            id: common_types_1.ApiFilterOperation.EQ,
            name: intl.formatMessage({
                id: 'EAS_TABLE_FILTER_CELL_SELECT_OPTION_EQUALS',
                defaultMessage: 'Vyplněno',
            }),
        },
        {
            id: common_types_1.ApiFilterOperation.IS_NULL,
            name: intl.formatMessage({
                id: 'EAS_TABLE_FILTER_CELL_SELECT_OPTION_NULL',
                defaultMessage: 'Nevyplněno',
            }),
        },
    ]);
}
//# sourceMappingURL=filter-nullable-select-cell.js.map